<template>
  <div class="wrapper">
    <v-btn
      icon
      absolute
      fab
      top
      right
      small
      dark
      class="inside"
      @click="close()"
      style="top: 16px !important;"
    >
      <v-icon v-text="'mdi-close'" />
    </v-btn>
    <v-date-picker
      :value="value"
      :allowed-dates="allowedDates"
      @change="e => update(e)"
    ></v-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    value: undefined,
    allowedDates: undefined,
  },
  data() {
    return {
      // picker: null,
    }
  },
  methods: {
    update(e, close = true) {
      console.log('JDatePicker.update()', e)
      // this.$emit('input', e)
      this.$emit('update:value', e)
      this.$emit('change', e)
      if (close) this.close()
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
}
</style>